import React from 'react';
import NewsDashboard from './components/NewsDashboard';
import ReactGA from 'react-ga4';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-QCS6SGLCP4');

function App() {
  return (
    <div className="App">
      <NewsDashboard />
    </div>
  );
}

export default App;